<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <el-row type="flex" justify="center">
      <lz-form ref="form" :get-data="getData" :submit="onSubmit" :form.sync="form" :errors.sync="errors" :edit-mode="editMode">
        <el-form-item label="仓库编码" required prop="code">
          <el-input v-model="form.code" :readonly="editMode" />
        </el-form-item>
        <el-form-item label="仓库名称" required prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="仓库省市地区" required prop="area_code">
          <el-cascader ref="CityCascader" :options="cascaderOptions" v-model="form.area_code" @change="handleChange" size="small" style="width: 100%;"></el-cascader>
        </el-form-item>
       <!-- <el-form-item label="所在城市" required prop="city">
          <el-input v-model="form.city" />
        </el-form-item>-->
        <el-form-item label="所在地址" required prop="address">
          <el-input v-model="form.address" />
        </el-form-item>
        <el-form-item label="联系方式" required prop="mobile">
          <el-input v-model="form.mobile" />
        </el-form-item>
        <el-form-item label="负责人员" required prop="username">
          <el-input v-model="form.username" />
        </el-form-item>
        <el-form-item label="关联小票打印机" prop="printerId">
          <el-select v-model="form.printerId" filterable clearable>
            <el-option v-for="item in printerDeviceList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <!--<el-form-item label="是否默认" prop="is_default">
          <el-switch v-model="form.is_default" :active-value="1" :inactive-value="0" active-text="已默认" inactive-text="非默认" />
        </el-form-item>-->
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import { createWarehouse, editWarehouse, storeWarehouse, updateWarehouse } from '@/api/warehouses'
import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'
import cityJson from '@c/CityCascader/assets/cityData';

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [FormHelper],
  data() {
    return {
      form: {
        code: '',
        name: '',
        city: '',
        area_code: [],
        area: '',
        address: '',
        mobile: '',
        username: '',
        printerId: '',
        is_default: 0,
      },
      newCityData: JSON.parse(JSON.stringify(cityJson)),
      cascaderOptions: {},
      printerDeviceList: [],
      errors: {},
    }
  },
  created() {
    let that = this;
    this.cascaderOptions = this.newCityData
      .filter(item => {
        return item.parentId === '100000';
      })
      .map(item => {
        let children = that.getCityData(item.id);
        let newchildren = children.map(citem => ({
          value: citem.value,
          label: citem.label,
          children: that.getCityData(citem.value)
        }));
        return {
          value: item.id,
          label: item.name,
          children: newchildren
        };
      });
  },
  methods: {
    handleChange(value) {
      console.log('handleChange:', value);
    },
    getCityData(id) {
      return this.newCityData
        .filter(item => {
          return item.parentId === id;
        })
        .map(item => ({
          value: item.id,
          label: item.name
        }));
    },
    async getData() {
      let data
      if (this.editMode) {
        ({ data } = await editWarehouse(this.resourceId))
        this.fillForm(data.warehouse)
        this.printerDeviceList = data.printerDeviceList;
      } else {
        ({ data } = await createWarehouse())
        this.printerDeviceList = data.printerDeviceList;
      }
    },
    async onSubmit() {
      this.form.area = this.$refs['CityCascader'].inputValue
      console.log('this.form.area', this.form.area, !this.form.area);
      if (!this.form.area) {
        this.$message.error("仓库省市地区不能为空");
        throw new Error('仓库省市地区不能为空')
        return;
      }

      this.form.area = this.form.area.replace(/\s*/g, '')
      if (this.editMode) {
        await updateWarehouse(this.resourceId, this.form)
      } else {
        await storeWarehouse(this.form)
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
